import { Screen } from '../api/types';

const noAvailablityMessage = 'No Tickets Available';

class ScreenButtonAriaLabelRenderer {
  constructor(private priceRangeSeparator: string) {
  }

  getAriaLabel({
    description,
    isAvailable,
    priceTypeDescription,
    screenButtonShouldDisplayPriceTypeDescription,
    screenButtonShouldRenderPriceRange,
    minPriceDisplay,
    maxPriceDisplay,
  }: Screen) {
    const values = [
      `${description}, `,
    ];

    if (isAvailable) {
      if (screenButtonShouldDisplayPriceTypeDescription) {
        values.push(priceTypeDescription);
        if (screenButtonShouldRenderPriceRange) {
          values.push(': ');
        }
      }

      if (screenButtonShouldRenderPriceRange) {
        values.push(minPriceDisplay);

        if (minPriceDisplay !== maxPriceDisplay) {
          values.push(' ');
          values.push(this.priceRangeSeparator);
          values.push(' ');
          values.push(maxPriceDisplay);
        }
      }
    } else {
      values.push(noAvailablityMessage);
    }

    return values.join('');
  }
}

export default ScreenButtonAriaLabelRenderer;
